import React from 'react';
import { Text } from '@leverege/ui-elements';
import VehicleInfoCard from '../components/VehicleInfoCard';
import LocatorInfoCard from '../components/LocatorInfoCard';
import CustomerInfoCard from '../components/CustomerInfoCard';
import SaleInfoCard from '../components/SaleInfoCard';
import S from './ConfirmRecovrSale.css';
import TagInfoCard from '../components/TagInfoCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConfirmRecovrSale(props) {
  const {
    vehicle,
    isNewCustomer,
    exAcct,
    newAcct,
    newLocator,
    salesperson,
    locatorSalesPrice,
    keys,
    keysSalesPrice,
    productTypes,
    qtyOfTags,
    knowTags
  } = props;
  const {
    recovr,
    recovrKeys
  } = productTypes;
  const keyForSale = keys ? Object.keys(keys).some(key => keys[key].sell) : false;
  return /*#__PURE__*/_jsxs("div", {
    className: S.container,
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "bodyBold",
      children: "Confirm Sale"
    }), /*#__PURE__*/_jsx(Text, {
      variant: "body",
      children: "Confirm the vehicle, locator, customer and information below before you complete the sale."
    }), /*#__PURE__*/_jsx(Text, {
      variant: "bodyBold",
      children: "Vehicle Information"
    }), /*#__PURE__*/_jsx(VehicleInfoCard, {
      vehicle: vehicle
    }), /*#__PURE__*/_jsx(Text, {
      variant: "bodyBold",
      children: "Customer Information"
    }), /*#__PURE__*/_jsx(CustomerInfoCard, {
      acct: isNewCustomer ? newAcct : exAcct
    }), recovr && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "bodyBold",
        children: "Locator Information"
      }), /*#__PURE__*/_jsx(LocatorInfoCard, {
        locatorSalesPrice: locatorSalesPrice,
        locator: newLocator || vehicle?.data?.data?.locator
      })]
    }), recovrKeys && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "bodyBold",
        children: "Tag Information"
      }), /*#__PURE__*/_jsx(TagInfoCard, {
        keys: keys,
        keysSalesPrice: keysSalesPrice,
        qtyOfTags: qtyOfTags,
        knowTags: knowTags
      })]
    }), /*#__PURE__*/_jsx(Text, {
      variant: "bodyBold",
      children: "Sale Information"
    }), /*#__PURE__*/_jsx(SaleInfoCard, {
      salesperson: salesperson,
      locatorSalesPrice: locatorSalesPrice,
      keysSalesPrice: keysSalesPrice
    })]
  });
}